<div class="align-center">
  <p>If you need further assistance, please contact our Customer Support team at:</p>
  <div class="mt-20 align-center">
    <p class="text-small align-center">
      GSO: <br /><a href="MEDSupport@EssilorUSA.com">MEDSupport&#64;EssilorUSA.com</a>
    </p>
  </div>
  <div class="mt-10 mb-20 align-center">
    <p class="text-small align-center">
      Milroy: <br /><a href="mailto:MEDSupport@EssilorUSA.com">MEDSupport&#64;EssilorUSA.com</a>
    </p>
  </div>
  Please use the login above to access your dashboard and orders!
</div>
